/**
 *Created by jmmartinez on 01/05/25
 **/

import React from 'react'
import PropTypes from 'prop-types';
import {FormGroup} from "@blueprintjs/core";
import DateTimeInput from "../../blueprint/DateTimeInput";
import {getFechayHoraDeDate, getFechayHoraDeTimestamp} from "../utils/DateUtils";

class SelectorFechaHora extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            //tFechaHoraInicial:  props.fechahoraInicial ? props.fechahoraInicial : new Date().getTime(),
            fecha: '',
            hora: '',
            opcionesHora: [],
        }
    }

    componentDidMount() {
        const { dtFechahoraInicial, horaInicial, horaFinal, intervaloMinutos } = this.props;
        //console.log("componentDidMount");
        let fechaYHora= getFechayHoraDeDate(dtFechahoraInicial);
        //console.log("fechaYHora: ", fechaYHora);
        let opcionesHoras= this.generarOpcionesHora(horaInicial, horaFinal, intervaloMinutos);
        //console.log("opcionesHoras: ", opcionesHoras);
        this.setState({ fecha: fechaYHora.fecha, hora: fechaYHora.hora, opcionesHora: opcionesHoras } );
    }

    asignarFechaYHoraDesdeInicial= (dtFechahoraInicial) => {

    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.dtFechahoraInicial !== prevState.dtFechahoraInicial) {
            newState.dtFechahoraInicial = nextProps.dtFechahoraInicial;
            let fechaYHora= getFechayHoraDeDate(nextProps.dtFechahoraInicial);
            newState.fecha= fechaYHora.fecha;
            newState.hora= fechaYHora.hora;

        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }



    generarOpcionesHora = (inicio, fin, minutos) => {
        const opciones = [];
        const [hInicio, mInicio] = inicio.split(':').map(Number);
        const [hFin, mFin] = fin.split(':').map(Number);

        let horaActual = new Date();
        horaActual.setHours(hInicio, mInicio, 0, 0);

        const horaLimite = new Date();
        horaLimite.setHours(hFin, mFin, 0, 0);

        while (horaActual <= horaLimite) {
            const hh = horaActual.getHours().toString().padStart(2, '0');
            const mm = horaActual.getMinutes().toString().padStart(2, '0');
            opciones.push(`${hh}:${mm}`);
            horaActual.setMinutes(horaActual.getMinutes() + minutos);
        }

        return opciones;
    };




    handleChange = (e) => {
        //Según el componente llamador variamos una de las dos variables del set
        console.log("HandleChange");
        let tipo = e.target.type === 'date' ? 'fecha' : 'hora';
        console.log("tipo: ", tipo);
        this.setState({ [tipo]: e.target.value}, this.onChange);
    };

    onChange = () => {
        const { fecha, hora } = this.state;
        const { onChange } = this.props;

        console.log("onChange: ");
        console.log("fecha: ", fecha);
        console.log("hora: ", hora);
        console.log("onChange: ", onChange);

        if (fecha && hora && onChange) {
            let cadenaDate= fecha + "T" + hora +":00";
            let date= new Date(cadenaDate);
            //let timestamp = new Date(cadenaDate).getTime();
            //onChange(timestamp);
            onChange(date);
        }
    };

    render() {
        const {fecha, hora, opcionesHora} = this.state;
        const {fechaReadOnly, dtFechahoraInicial} = this.props;
        let fechaReadOnlyReal = fechaReadOnly ? Boolean(fechaReadOnly) : false;

        console.log("RENDER");
        //console.log("dtFechahoraInicial: ", new Date(dtFechahoraInicial));
        console.log("fecha: ", fecha);
        console.log("hora: ", hora);

        return(
            <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', alignItems: 'center'}}>
                <input
                    type="date"
                    value={fecha}
                    onChange={this.handleChange}
                    readOnly={fechaReadOnlyReal}
                    style={{ width: '150px', padding: '8px', margin: '2px' }}
                />

                <select
                    value={hora}
                    onChange={this.handleChange}
                    style={{ width: '100px', padding: '8px', margin: '2px' }} >
                    {opcionesHora.map((horaStr) => (
                        <option key={horaStr} value={horaStr}> {horaStr} </option>
                    ))}
                </select>
            </div>
        );
    }

}


SelectorFechaHora.propTypes = {
    //tsFechahoraInicial: PropTypes.number,
    dtFechahoraInicial: PropTypes.object,
    horaInicial: PropTypes.string,
    horaFinal: PropTypes.string,
    intervaloMinutos: PropTypes.number,

    onChange: PropTypes.func,
    fechaReadOnly: PropTypes.bool,

}

export default SelectorFechaHora;

